// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"c5039b45","99":"90971b5d","146":"6656b40d","175":"345f6374","204":"c0924295","349":"e6376444","479":"aec9809b","655":"9c245a90","674":"e1a743a3","768":"3ec71c28","813":"c2d866ba","963":"ca695190"}[chunkId] + ".chunk.js";
};